import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.logout');
import { OnInit, Input } from '@angular/core';

@Component({
    selector: 'wiz-page-logout',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/page.logout/view.scss */
:host {
  display: block;
}`],
})
export class PageLogoutComponent implements OnInit {
    @Input() title: any;

    public async ngOnInit() {
        const { code, data } = await wiz.call("get_user_id");

        if (typeof AppInterface != 'undefined') {
            AppInterface.removeUserId(data);
        }

        location.href = "/auth/logout";
    }
}

export default PageLogoutComponent;